import {make} from "vuex-pathify";
import {BotService} from "@/services";
import store from "@/store";
import AppService from "@/services/app.service";
import helpers from "@/util/helpers";

const state = {
    items: [],
    search: ''
}
const mutations = make.mutations(state)

const actions = {
    ...make.actions(state),
    findAll({dispatch}) {
        store.set('app/loading', true)
        BotService.findAll()
            .then((result) => {
                dispatch('setItems', result.data)
            })
            .catch(() => {
                AppService.toastError("Get list Bot failed")
            })
            .finally(() => {
                store.set('app/loading', false)
            })
    }
}

const getters = {
    filteredItems: (state) => {
        const _search = helpers.removeVietnameseTones(state.search).toLowerCase()
        return state.items.filter(item => {
            const name = helpers.removeVietnameseTones(item.name)
            const code = helpers.removeVietnameseTones(item.code)
            return (name.toLowerCase().includes(_search) || code.toLowerCase().includes(_search))
        })
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
